<div class="header">
    <img src="https://fodimi.pl/img/site_logo/logo_4.png">
</div>
<ng-container  *ngIf="!formSent">
    <div class="content-container form-elem" [formGroup]="form">
        <h3>{{ 'AUTH.LEAD_FORM_TITLE' | translate }}</h3>
        <div class="form mt-3">
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" type="number" formControlName="partnerTaxId" [ngClass]="{ 'is-invalid':submitted && !form.get('partnerTaxId').valid}">
                    <label>{{ 'AUTH.LEAD_FORM_PARTNER_TAX_ID' | translate }}</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" formControlName="restaurantName" [ngClass]="{ 'is-invalid':submitted && !form.get('restaurantName').valid}">
                    <label>{{ 'INIT_WIZARD.RESTAURANT_NAME' | translate }}</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" formControlName="name" [ngClass]="{ 'is-invalid':submitted && !form.get('name').valid}">
                    <label>{{ 'AUTH.LEAD_FORM_CONTACT_NAME' | translate }}</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" type="number" formControlName="taxId" [ngClass]="{ 'is-invalid':submitted && !form.get('taxId').valid}">
                    <label>{{ 'AUTH.LEAD_FORM_TAX_ID' | translate }}</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control"   formControlName="phone"  [ngClass]="{ 'is-invalid':submitted && !form.get('phone').valid}">
                    <label>{{ 'INIT_WIZARD.PHONE_NUMBER' | translate }}</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" formControlName="email"  [ngClass]="{ 'is-invalid':submitted && !form.get('email').valid}">
                    <label>{{ 'AUTH.CONTACT_FORM_EMAIL' | translate }}</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <textarea class="form-control" formControlName="comment"  [ngClass]="{ 'is-invalid':submitted && !form.get('comment').valid}"></textarea>
                    <label>{{ 'AUTH.LEAD_FORM_COMMENT' | translate }}</label>
                </div>
            </div>

        </div>
        <div class="text-center">
            <button class="btn btn-primary" (click)="save()" [disabled]="!form.valid">{{ 'AUTH.LEAD_FORM_SUBMIT' | translate }}</button>
            <a  href="https://fodimi.pl"><button class="ml-2 btn btn-outline-primary">{{ 'AUTH.BACK_TO_HOME' | translate }}</button></a>
        </div>
    </div>
</ng-container>
<ng-container  *ngIf="formSent">
    <div class="content-container">
        <img src="assets/img/done.svg" width="100">
        <h4 class="mb-4 mt-4">{{ 'AUTH.LEAD_FORM_SUCCESS' | translate }}</h4>
        <div class="text-center">
            <a  href="https://fodimi.pl"><button class="btn btn-primary">{{ 'AUTH.BACK_TO_HOME' | translate }}</button></a>
        </div>
    </div>

</ng-container>
